if (!customElements.get('wlsn-whats-inside')) {
    class WLSNWhatsInside extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                group: '.js-wlsn-whats-inside-group',
                accordion: '.js-wlsn-accordion',
                pill: '.js-wlsn-whats-inside-pill',
            };
            this.pills = [];
            this.isVisible = false;
            this.ticking = false;
            this.onScroll = this.onScroll.bind(this);
            this.update = this.update.bind(this);
        }

        connectedCallback() {
            this.openDefaultGroups();

            if (this.dataset.parallax !== 'true') return;
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

            this.pills = Array.from(this.querySelectorAll(this.selectors.pill));
            if (!this.pills.length) return;

            this.observer = new IntersectionObserver((entries) => {
                this.isVisible = entries[0].isIntersecting;
                if (this.isVisible) this.onScroll();
            });
            this.observer.observe(this);

            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.onScroll();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
            if (this.observer) this.observer.disconnect();
        }

        openDefaultGroups() {
            this.querySelectorAll(this.selectors.group).forEach((group) => {
                if (group.dataset.openDefault !== 'true') return;

                const accordion = group.querySelector(this.selectors.accordion);
                if (accordion) accordion.classList.add('open');
            });
        }

        onScroll() {
            if (!this.isVisible || this.ticking) return;

            this.ticking = true;
            window.requestAnimationFrame(this.update);
        }

        update() {
            const rect = this.getBoundingClientRect();
            const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height) - 0.5;

            this.pills.forEach((pill) => {
                const depth = parseFloat(pill.dataset.depth) || 0;
                pill.style.transform = `translate3d(0, ${(progress * depth).toFixed(2)}px, 0)`;
            });

            this.ticking = false;
        }
    }

    customElements.define('wlsn-whats-inside', WLSNWhatsInside);
}
